import React from 'react';
import { subscribeRealtimeBidAsk } from '../reducer';
import IndexSumary from './../top-content/index-summary';
import GroupButton from './../top-content/group-button';
import IndexInfor from './../top-content/index-infor';
import { connect } from 'react-redux';
import SearchBox from './SearchBox';
import {
  REDUCER_NAME,
  subscribeRealtimeTick,
  subscribeRealtimeIndex,
} from './../reducer';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import { isTicker } from '../../../helpers/Common';
import Const from '../../../common/Const';
import { getDataFollowKeyByDot } from '../../../helpers/Common';
import { compose } from 'redux';
import { withComponentId } from './../../../common/ComponentIdContext';

class InfoIndex extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 1,
    };
  }

  componentDidMount() {
    MessageHub.subscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
    MessageHub.subscribe(
      ChanelConfig.IndexChannel,
      this.dispatchDataRealtimeIndex,
    );
    MessageHub.subscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(
      ChanelConfig.TickChanel,
      this.dispatchDataRealtimeTick,
    );
    MessageHub.unsubscribe(
      ChanelConfig.IndexChannel,
      this.dispatchDataRealtimeIndex,
    );
    MessageHub.unsubscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
  }

  onReceiveBidAsk = bidAsks => {
    const { code, dispatch, componentId } = this.props;
    const data = bidAsks.find(item => item.organCode === code);
    if (data) {
      dispatch(
        subscribeRealtimeBidAsk({ [data.organCode]: data }, componentId),
      );
    }
  };

  formatPriceInfoByTypeSearch = (isRealTime, isTicker, indexSumaryRealTime) => {
    if (isRealTime) {
      return {
        MatchPrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          isTicker ? Const.indexData.VALUE : Const.comgroupData.INDEX_VALUE,
        ),
        ReferencePrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          isTicker
            ? Const.indexData.REFERENCE_PRICE
            : Const.comgroupData.REFERENCE_INDEX,
        ),
        PriceChange: getDataFollowKeyByDot(
          indexSumaryRealTime,
          isTicker
            ? Const.indexData.VALUE_CHANGE
            : Const.comgroupData.INDEX_CHANGE,
        ),
        PercentPriceChange: getDataFollowKeyByDot(
          indexSumaryRealTime,
          isTicker
            ? Const.indexData.PERCENT_VALUE_CHANGE
            : Const.comgroupData.PERCENT_INDEX_CHANGE,
        ),
        CeilingPrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          isTicker
            ? Const.indexData.CEILING_PRICE
            : Const.comgroupData.CEILING_PRICE,
        ),
        FloorPrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          isTicker
            ? Const.indexData.FLOOR_PRICE
            : Const.comgroupData.FLOOR_PRICE,
        ),
        TradingDate: indexSumaryRealTime.tradingDate,
        marketStatus: indexSumaryRealTime.marketStatus,
      };
    } else {
      return {
        MatchPrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          Const.indexData.VALUE,
        ),
        ReferencePrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          Const.indexData.REFERENCE_PRICE,
        ),
        PriceChange: getDataFollowKeyByDot(
          indexSumaryRealTime,
          Const.indexData.VALUE_CHANGE,
        ),
        PercentPriceChange: getDataFollowKeyByDot(
          indexSumaryRealTime,
          Const.indexData.PERCENT_VALUE_CHANGE,
        ),
        CeilingPrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          Const.indexData.CEILING_PRICE,
        ),
        FloorPrice: getDataFollowKeyByDot(
          indexSumaryRealTime,
          Const.indexData.FLOOR_PRICE,
        ),
        marketStatus: indexSumaryRealTime.marketStatus,
      };
    }
  };

  initialDataInfoHeader = () => {
    const realtimeInfo = this.getRealtimeData();
    const { indexSumary } = this.props;

    return this.formatPriceInfoByTypeSearch(
      realtimeInfo.isRealTime,
      isTicker(indexSumary),
      realtimeInfo.indexSumanyToProp,
    );
  };

  dispatchDataRealtimeTick = payload => {
    const { componentId, dispatch, code } = this.props;
    const data = payload.find(item => item.organCode === code);
    if (!data) {
      return;
    }
    dispatch(subscribeRealtimeTick(data, componentId));
  };

  dispatchDataRealtimeIndex = payload => {
    const { componentId, dispatch, code } = this.props;
    const data = payload.find(item => item.comGroupCode === code);

    if (!data) {
      return;
    }
    dispatch(subscribeRealtimeIndex(data, componentId));
  };

  getRealtimeData = () => {
    const { indexSumaryRealTime, indexSumary } = this.props;
    let indexSumanyToProp = {};

    const isRealTime =
      Object.keys(indexSumaryRealTime).length &&
      indexSumary.organCode ===
        (isTicker(indexSumary)
          ? indexSumaryRealTime.organCode
          : indexSumaryRealTime.comGroupCode);

    if (isRealTime) {
      indexSumanyToProp = indexSumaryRealTime;
    } else {
      indexSumanyToProp = indexSumary;
    }
    return { indexSumanyToProp, isRealTime };
  };

  render() {
    return (
      <>
        <div>
          <SearchBox />
        </div>
        <div className="left-info-widget__metas ml-20">
          <IndexSumary data={this.initialDataInfoHeader()} />
        </div>
        <IndexInfor data={this.initialDataInfoHeader()} />
        <GroupButton />
      </>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    indexSumaryRealTime:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumaryRealTime,
    code:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch.code,
    indexSumary:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumary,
    bidAskRealtimeData:
      state[REDUCER_NAME].listMultiComponent[componentId].bidAskRealtimeData,
  };
};

export default compose(
  withComponentId,
  connect(mapStateToProps),
)(InfoIndex);
